/* eslint-disable */
// src/pages/PublicFeed.jsx — Light theme, Posts/Saved tabs, Thoughts, Polls
// Updated: full-image horizontal scroll carousel (contain), collage grid, fullscreen lightbox, PDF cards
// PATCHED: fixed share link, formatted (HTML) pravachan notes now render correctly,
//          Thought composer is now rich-text (bold/italic/underline/color) + photo/video upload
//          with a Twitter-style horizontal-scroll gallery in the feed.

import React, { useEffect, useState, useRef, useCallback } from 'react';
import { dbRealtime, storage } from '../environments/firebase';
import { ref, get, update } from 'firebase/database';
import { ref as storageRef, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useAuth } from '../contexts/AuthContext';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// ─── Light Theme ─────────────────────────────────────────────
const T = {
  bg:       '#F7F5F0',
  surface:  '#FFFFFF',
  surface2: '#F0EDE8',
  border:   '#E5E0D8',
  text:     '#1A1714',
  muted:    '#8A8178',
  accent:   '#C2610A',
  accentBg: '#FEF3E8',
  green:    '#15803D',
  red:      '#DC2626',
  shadow:   '0 1px 3px rgba(0,0,0,0.07), 0 1px 2px rgba(0,0,0,0.04)',
  shadowMd: '0 4px 12px rgba(0,0,0,0.08)',
};

// ─── Icons ────────────────────────────────────────────────────
const Ic = {
  Heart:    ({ fill }) => <svg width="22" height="22" fill={fill ? T.red : 'none'} stroke={fill ? T.red : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>,
  Comment:  () => <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>,
  Share:    () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  Bookmark: ({ fill }) => <svg width="20" height="20" fill={fill ? T.accent : 'none'} stroke={fill ? T.accent : 'currentColor'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/></svg>,
  Play:     () => <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Pause:    () => <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>,
  More:     () => <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>,
  Send:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>,
  Refresh:  () => <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></svg>,
  Plus:     () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Delete:   () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>,
  Anon:     () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/><line x1="17" y1="3" x2="21" y2="7"/></svg>,
  Check:    () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>,
  Close:    () => <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Expand:   () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></svg>,
  ExtLink:  () => <svg width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>,
  Bold:     () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6z"/><path d="M6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z"/></svg>,
  Italic:   () => <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><line x1="19" y1="4" x2="10" y2="4"/><line x1="14" y1="20" x2="5" y2="20"/><line x1="15" y1="4" x2="9" y2="20"/></svg>,
  ImageIcon: () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  Video:    () => <svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg>,
};

// ─── Helpers ──────────────────────────────────────────────────
const timeAgo = (ts) => {
  const d = Date.now() - ts, m = Math.floor(d/60000), h = Math.floor(d/3600000), dy = Math.floor(d/86400000);
  if (m < 1) return 'just now'; if (m < 60) return `${m}m`; if (h < 24) return `${h}h`; if (dy < 7) return `${dy}d`;
  return new Date(ts).toLocaleDateString('en-US', { month:'short', day:'numeric' });
};

const stripHtml = (html) => { const d = document.createElement('div'); d.innerHTML = html||''; return d.textContent||d.innerText||''; };

// ─── Fullscreen Lightbox ──────────────────────────────────────
function Lightbox({ images, startIdx, onClose }) {
  const [idx, setIdx] = useState(startIdx || 0);
  const prev = () => setIdx(i => Math.max(0, i - 1));
  const next = () => setIdx(i => Math.min(images.length - 1, i + 1));

  // Keyboard nav
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.95)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {/* Close */}
      <button onClick={onClose} style={{ position: 'absolute', top: 16, right: 16, background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 40, height: 40, color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)', zIndex: 10 }}>
        <Ic.Close />
      </button>

      {/* Counter */}
      {images.length > 1 && (
        <div style={{ position: 'absolute', top: 20, left: '50%', transform: 'translateX(-50%)', background: 'rgba(255,255,255,0.15)', borderRadius: 20, padding: '4px 14px', color: '#fff', fontSize: 13, fontWeight: 600 }}>
          {idx + 1} / {images.length}
        </div>
      )}

      {/* Image */}
      <AnimatePresence mode="wait">
        <motion.img key={idx} src={images[idx]} initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.96 }} transition={{ duration: 0.18 }}
          style={{ maxWidth: '95vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 8, userSelect: 'none' }} />
      </AnimatePresence>

      {/* Prev / Next */}
      {images.length > 1 && idx > 0 && (
        <button onClick={prev} style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 44, height: 44, color: '#fff', cursor: 'pointer', fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>‹</button>
      )}
      {images.length > 1 && idx < images.length - 1 && (
        <button onClick={next} style={{ position: 'absolute', right: 16, top: '50%', transform: 'translateY(-50%)', background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: '50%', width: 44, height: 44, color: '#fff', cursor: 'pointer', fontSize: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(4px)' }}>›</button>
      )}

      {/* Thumbnail strip */}
      {images.length > 1 && (
        <div style={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: 6, padding: '8px 12px', background: 'rgba(0,0,0,0.5)', borderRadius: 12 }}>
          {images.map((url, i) => (
            <button key={i} onClick={() => setIdx(i)} style={{ width: i === idx ? 36 : 28, height: 28, borderRadius: 6, overflow: 'hidden', border: `2px solid ${i === idx ? '#fff' : 'transparent'}`, padding: 0, cursor: 'pointer', transition: 'all 0.2s', flexShrink: 0 }}>
              <img src={url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </button>
          ))}
        </div>
      )}
    </motion.div>
  );
}

// ─── Image Gallery — Instagram-style horizontal scroll + collage ──
//  • 1 image  → full width, contain (entire image visible, no crop)
//  • 2 images → side-by-side contain tiles
//  • 3+ images → horizontal scroll carousel (contain, snap), with "View all" button
function PostImageGallery({ images, onOpenLightbox }) {
  const scrollRef = useRef(null);
  const [scrollIdx, setScrollIdx] = useState(0);

  const onScroll = () => {
    if (!scrollRef.current) return;
    setScrollIdx(Math.round(scrollRef.current.scrollLeft / scrollRef.current.offsetWidth));
  };

  if (!images || images.length === 0) return null;

  // Single image — full width, object-contain so whole image visible
  if (images.length === 1) {
    return (
      <div style={{ position: 'relative', background: '#111', borderRadius: 0 }}>
        <img src={images[0]} style={{ width: '100%', maxHeight: 340, objectFit: 'contain', display: 'block' }} loading="lazy" />
        <button onClick={() => onOpenLightbox(0)}
          style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: 8, padding: '5px 8px', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, backdropFilter: 'blur(4px)' }}>
          <Ic.Expand /> Full
        </button>
      </div>
    );
  }

  // Two images — side by side, each contain
  if (images.length === 2) {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, background: '#111' }}>
        {images.map((url, i) => (
          <div key={i} style={{ position: 'relative', cursor: 'pointer' }} onClick={() => onOpenLightbox(i)}>
            <img src={url} style={{ width: '100%', height: 200, objectFit: 'contain', display: 'block', background: '#1a1a1a' }} loading="lazy" />
          </div>
        ))}
      </div>
    );
  }

  // 3–4 images — collage grid (no crop madness — use contain in each cell)
  if (images.length <= 4) {
    const cols = images.length === 3 ? '1fr 1fr 1fr' : '1fr 1fr';
    return (
      <div style={{ position: 'relative', background: '#111' }}>
        <div style={{ display: 'grid', gridTemplateColumns: cols, gap: 2 }}>
          {images.map((url, i) => (
            <div key={i} onClick={() => onOpenLightbox(i)} style={{ position: 'relative', cursor: 'pointer' }}>
              <img src={url} style={{ width: '100%', height: images.length === 3 ? 160 : 180, objectFit: 'contain', display: 'block', background: '#1a1a1a' }} loading="lazy" />
            </div>
          ))}
        </div>
        <button onClick={() => onOpenLightbox(0)}
          style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: 8, padding: '5px 8px', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, backdropFilter: 'blur(4px)' }}>
          <Ic.Expand /> All {images.length}
        </button>
      </div>
    );
  }

  // 5+ images → horizontal scroll carousel, each slide: contain image
  return (
    <div style={{ position: 'relative', background: '#111' }}>
      {/* Scroll container */}
      <div
        ref={scrollRef}
        onScroll={onScroll}
        style={{
          display: 'flex',
          overflowX: 'scroll',
          scrollSnapType: 'x mandatory',
          scrollbarWidth: 'none',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {images.map((url, i) => (
          <div key={i} onClick={() => onOpenLightbox(i)}
            style={{
              minWidth: '100%', scrollSnapAlign: 'start', flexShrink: 0,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: '#111', height: 300, cursor: 'pointer', position: 'relative',
            }}>
            <img src={url} style={{ maxWidth: '100%', maxHeight: 300, objectFit: 'contain', display: 'block' }} loading="lazy" />
            {/* Slide number */}
            <div style={{ position: 'absolute', top: 8, left: 8, background: 'rgba(0,0,0,0.55)', borderRadius: 20, padding: '3px 10px', fontSize: 12, color: '#fff', fontWeight: 600 }}>
              {i + 1}/{images.length}
            </div>
          </div>
        ))}
      </div>

      {/* Dot indicators */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 4, padding: '6px 0', background: T.surface }}>
        {images.map((_, i) => (
          <button key={i}
            onClick={() => { scrollRef.current?.scrollTo({ left: i * scrollRef.current.offsetWidth, behavior: 'smooth' }); setScrollIdx(i); }}
            style={{ width: i === scrollIdx ? 16 : 6, height: 6, borderRadius: 3, background: i === scrollIdx ? T.accent : T.border, border: 'none', padding: 0, cursor: 'pointer', transition: 'all 0.2s' }} />
        ))}
      </div>

      {/* Expand button */}
      <button onClick={() => onOpenLightbox(scrollIdx)}
        style={{ position: 'absolute', top: 8, right: 8, background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: 8, padding: '5px 8px', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, backdropFilter: 'blur(4px)' }}>
        <Ic.Expand /> Full
      </button>
    </div>
  );
}

// ─── Thread-style Media Gallery (Thoughts) — always horizontal scroll, mixed image/video ──
function ThreadMediaGallery({ media, onOpenLightbox }) {
  const scrollRef = useRef(null);
  const [idx, setIdx] = useState(0);
  if (!media || media.length === 0) return null;

  const onScroll = () => {
    if (!scrollRef.current) return;
    setIdx(Math.round(scrollRef.current.scrollLeft / scrollRef.current.offsetWidth));
  };

  // Map of image-only index lookups for the lightbox (videos are skipped in lightbox)
  const imageUrls = media.filter(m => m.type === 'image').map(m => m.url);

  return (
    <div style={{ position: 'relative', marginTop: 10, borderRadius: 14, overflow: 'hidden', border: `1px solid ${T.border}` }}>
      <div
        ref={scrollRef}
        onScroll={onScroll}
        style={{ display: 'flex', overflowX: 'scroll', scrollSnapType: 'x mandatory', scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch', background: '#111' }}
      >
        {media.map((m, i) => (
          <div key={i}
            style={{ minWidth: '100%', scrollSnapAlign: 'start', flexShrink: 0, height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#111', cursor: m.type === 'image' ? 'pointer' : 'default', position: 'relative' }}
            onClick={() => { if (m.type === 'image') onOpenLightbox(imageUrls.indexOf(m.url)); }}>
            {m.type === 'video'
              ? <video src={m.url} controls style={{ maxWidth: '100%', maxHeight: 280 }} />
              : <img src={m.url} style={{ maxWidth: '100%', maxHeight: 280, objectFit: 'contain' }} loading="lazy" />}
            {media.length > 1 && (
              <div style={{ position: 'absolute', top: 8, left: 8, background: 'rgba(0,0,0,0.55)', borderRadius: 20, padding: '3px 10px', fontSize: 12, color: '#fff', fontWeight: 600 }}>
                {i + 1}/{media.length}
              </div>
            )}
          </div>
        ))}
      </div>
      {media.length > 1 && (
        <div style={{ display: 'flex', justifyContent: 'center', gap: 4, padding: '6px 0', background: T.surface }}>
          {media.map((_, i) => (
            <button key={i}
              onClick={() => { scrollRef.current?.scrollTo({ left: i * scrollRef.current.offsetWidth, behavior: 'smooth' }); setIdx(i); }}
              style={{ width: i === idx ? 16 : 6, height: 6, borderRadius: 3, background: i === idx ? T.accent : T.border, border: 'none', padding: 0, cursor: 'pointer', transition: 'all 0.2s' }} />
          ))}
        </div>
      )}
    </div>
  );
}

// ─── PDF Card in Feed ─────────────────────────────────────────
function FeedPdfCard({ pdf }) {
  return (
    <a href={pdf.url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none', display: 'block' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#FFF7ED', border: `1px solid #FED7AA`, borderRadius: 12, padding: '11px 14px', cursor: 'pointer', transition: 'background 0.15s' }}
        onMouseEnter={e => e.currentTarget.style.background = '#FFEDD5'}
        onMouseLeave={e => e.currentTarget.style.background = '#FFF7ED'}>
        <div style={{ width: 36, height: 36, borderRadius: 9, background: '#DC2626', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <span style={{ color: '#fff', fontSize: 9, fontWeight: 800, letterSpacing: '0.03em' }}>PDF</span>
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: T.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pdf.label || 'PDF Attachment'}</p>
          <p style={{ margin: '2px 0 0', fontSize: 11, color: T.muted }}>Tap to open</p>
        </div>
        <span style={{ color: T.accent, display: 'flex', alignItems: 'center', gap: 3, fontSize: 12, fontWeight: 600, flexShrink: 0 }}>Open <Ic.ExtLink /></span>
      </div>
    </a>
  );
}

// ─── MiniAudioPlayer ─────────────────────────────────────────
function MiniAudioPlayer({ src }) {
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(0);
  const audioRef = useRef(null);
  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) { audioRef.current.pause(); setPlaying(false); }
    else { audioRef.current.play().catch(()=>{}); setPlaying(true); }
  };
  const pct = dur ? (time/dur)*100 : 0;
  const fmt = (s) => `${Math.floor(s/60)}:${Math.floor(s%60).toString().padStart(2,'0')}`;
  return (
    <div style={{ display:'flex', alignItems:'center', gap:10, background:T.surface2, borderRadius:12, padding:'10px 14px', border:`1px solid ${T.border}` }}>
      <button onClick={toggle} style={{ width:34, height:34, borderRadius:'50%', background:T.accent, display:'flex', alignItems:'center', justifyContent:'center', border:'none', cursor:'pointer', color:'#fff', flexShrink:0 }}>
        {playing ? <Ic.Pause /> : <Ic.Play />}
      </button>
      <div style={{ flex:1, display:'flex', alignItems:'flex-end', gap:2, height:24, cursor:'pointer' }}
        onClick={e => { if (!audioRef.current||!dur) return; const r = e.currentTarget.getBoundingClientRect(); audioRef.current.currentTime = ((e.clientX-r.left)/r.width)*dur; }}>
        {[...Array(28)].map((_,i) => {
          const barH = 5 + Math.sin(i*0.7)*6 + Math.sin(i*1.3)*4;
          const filled = (i/28)*100 < pct;
          return <div key={i} style={{ flex:1, height:`${barH}px`, borderRadius:2, background: filled ? T.accent : T.border, transition:'background 0.1s' }} />;
        })}
      </div>
      <span style={{ fontSize:11, color:T.muted, minWidth:32, textAlign:'right' }}>{playing ? fmt(time) : fmt(dur)}</span>
      <audio ref={audioRef} src={src} onTimeUpdate={() => setTime(audioRef.current?.currentTime||0)} onLoadedMetadata={() => setDur(audioRef.current?.duration||0)} onEnded={() => setPlaying(false)} />
    </div>
  );
}

// ─── Poll Card ────────────────────────────────────────────────
function PollCard({ post, currentUid, onVote }) {
  const options = post.pollOptions || [];
  const votes = post.pollVotes || {};
  const totalVotes = Object.values(votes).length;
  const userVote = currentUid ? votes[currentUid] : null;
  const hasVoted = userVote !== null && userVote !== undefined;
  const isAnon = post.pollAnonymous;
  const optionCounts = options.map((_, i) => Object.values(votes).filter(v => v === i).length);
  return (
    <div style={{ padding:'0 14px 12px' }}>
      <p style={{ margin:'0 0 10px', fontSize:15, fontWeight:700, color:T.text, lineHeight:1.4 }}>{post.question}</p>
      <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
        {options.map((opt, i) => {
          const count = optionCounts[i];
          const pct = totalVotes > 0 ? Math.round((count/totalVotes)*100) : 0;
          const isChosen = userVote === i;
          return (
            <button key={i} onClick={() => !hasVoted && currentUid && onVote(post.id, i)}
              disabled={hasVoted || !currentUid}
              style={{ position:'relative', overflow:'hidden', border:`1.5px solid ${isChosen ? T.accent : T.border}`, borderRadius:10, padding:'10px 14px', background: isChosen ? T.accentBg : T.surface, cursor: hasVoted || !currentUid ? 'default' : 'pointer', textAlign:'left', transition:'all 0.2s' }}>
              {hasVoted && <div style={{ position:'absolute', left:0, top:0, height:'100%', width:`${pct}%`, background: isChosen ? 'rgba(194,97,10,0.12)' : 'rgba(0,0,0,0.04)', transition:'width 0.5s', borderRadius:10 }} />}
              <div style={{ position:'relative', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ fontSize:14, fontWeight:600, color: isChosen ? T.accent : T.text }}>{opt}</span>
                {hasVoted && <span style={{ fontSize:12, fontWeight:700, color: isChosen ? T.accent : T.muted }}>{pct}%</span>}
                {isChosen && <span style={{ color:T.accent, marginLeft:4 }}><Ic.Check /></span>}
              </div>
            </button>
          );
        })}
      </div>
      <div style={{ display:'flex', alignItems:'center', gap:6, marginTop:8 }}>
        <span style={{ fontSize:11, color:T.muted }}>{totalVotes} vote{totalVotes !== 1 ? 's' : ''}</span>
        {isAnon && <span style={{ fontSize:11, color:T.muted, display:'flex', alignItems:'center', gap:3 }}><Ic.Anon /> anonymous poll</span>}
        {!currentUid && <span style={{ fontSize:11, color:T.muted }}>· <Link to="/login" style={{ color:T.accent, fontWeight:600 }}>Sign in</Link> to vote</span>}
      </div>
    </div>
  );
}

// ─── Skeleton ─────────────────────────────────────────────────
function Skeleton() {
  return (
    <div style={{ background:T.surface, borderRadius:16, marginBottom:10, overflow:'hidden', border:`1px solid ${T.border}` }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, padding:'12px 14px' }}>
        <div style={{ width:38, height:38, borderRadius:'50%', background:T.surface2 }} />
        <div style={{ flex:1 }}>
          <div style={{ height:10, width:100, background:T.surface2, borderRadius:4, marginBottom:6 }} />
          <div style={{ height:8, width:60, background:T.border, borderRadius:4 }} />
        </div>
      </div>
      <div style={{ height:200, background:T.surface2 }} />
      <div style={{ padding:'12px 14px' }}>
        <div style={{ height:8, width:'60%', background:T.surface2, borderRadius:4, marginBottom:8 }} />
        <div style={{ height:8, width:'80%', background:T.border, borderRadius:4 }} />
      </div>
    </div>
  );
}

// ─── PostCard ─────────────────────────────────────────────────
function PostCard({ post, currentUid, onLike, onComment, onDeleteComment, onSave, onShare, onDelete, onVote }) {
  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState('');
  const [showMenu, setShowMenu] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [lightbox, setLightbox] = useState(null); // { images, startIdx }
  const inputRef = useRef(null);

  const liked   = currentUid ? !!(post.likes?.[currentUid]) : false;
  const saved   = currentUid ? !!(post.saves?.[currentUid]) : false;
  const isOwner = currentUid && currentUid === post.userId;
  const images  = Array.isArray(post.images) ? post.images.filter(Boolean) : [];
  const audios  = Array.isArray(post.audioFiles) ? post.audioFiles.filter(Boolean) : [];
  const pdfs    = Array.isArray(post.pdfFiles) ? post.pdfFiles.filter(Boolean) : [];
  const media   = Array.isArray(post.media) ? post.media.filter(m => m && m.url) : []; // thought media
  // Notes are stored as HTML (rich text from the Pravachan editor) — render as HTML, not plain text.
  const plainNotesLen = stripHtml(post.notes||'').length;
  const isLong  = plainNotesLen > 150;
  const comments = Object.values(post.comments||{}).sort((a, b) => a.createdAt - b.createdAt);
  const isPoll  = post.type === 'poll';
  const isThought = post.type === 'thought';

  const submit = () => { if (!commentText.trim()) return; onComment(post.id, commentText.trim()); setCommentText(''); };

  const lastTap = useRef(0);
  const handleDoubleTap = () => { const now = Date.now(); if (now - lastTap.current < 300 && currentUid) { onLike(post.id); } lastTap.current = now; };

  const typeBadge = isPoll ? { label:'Poll', color:'#7C3AED', bg:'rgba(124,58,237,0.08)' }
    : isThought ? { label:'Thought', color:'#1D9E75', bg:'rgba(29,158,117,0.08)' }
    : null;

  return (
    <>
      {/* Lightbox */}
      <AnimatePresence>
        {lightbox && <Lightbox images={lightbox.images} startIdx={lightbox.startIdx} onClose={() => setLightbox(null)} />}
      </AnimatePresence>

      <article style={{ background:T.surface, marginBottom:10, borderRadius:16, border:`1px solid ${T.border}`, overflow:'hidden', boxShadow:T.shadow }}>
        {/* Header */}
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 14px' }}>
          <div style={{ display:'flex', alignItems:'center', gap:10 }}>
            <div style={{ width:38, height:38, borderRadius:'50%', flexShrink:0, overflow:'hidden', background:'linear-gradient(135deg,#C2610A,#15803D)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:700, color:'#fff' }}>
              {post.avatarUrl ? <img src={post.avatarUrl} style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : (post.avatarInitial||'?')}
            </div>
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                <p style={{ margin:0, fontSize:13, fontWeight:700, color:T.text }}>{post.displayName}</p>
                {typeBadge && (
                  <span style={{ fontSize:10, fontWeight:700, color:typeBadge.color, background:typeBadge.bg, borderRadius:20, padding:'2px 8px', border:`1px solid ${typeBadge.color}30` }}>{typeBadge.label}</span>
                )}
              </div>
              <p style={{ margin:0, fontSize:11, color:T.muted }}>{timeAgo(post.createdAt)}</p>
            </div>
          </div>

          <div style={{ position:'relative' }}>
            <button onClick={() => setShowMenu(!showMenu)} style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:'4px 8px', borderRadius:8 }}>
              <Ic.More />
            </button>
            <AnimatePresence>
              {showMenu && (
                <motion.div initial={{ opacity:0, scale:0.95, y:-4 }} animate={{ opacity:1, scale:1, y:0 }} exit={{ opacity:0 }}
                  style={{ position:'absolute', right:0, top:'100%', background:T.surface, border:`1px solid ${T.border}`, borderRadius:12, padding:4, zIndex:20, minWidth:140, boxShadow:T.shadowMd }}>
                  <button onClick={() => { onShare(post); setShowMenu(false); }} style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'10px 12px', background:'none', border:'none', color:T.text, fontSize:13, cursor:'pointer', borderRadius:8 }}>
                    <Ic.Share /> Share
                  </button>
                  {isOwner && (
                    <button onClick={() => { onDelete(post.id); setShowMenu(false); }} style={{ display:'flex', alignItems:'center', gap:8, width:'100%', padding:'10px 12px', background:'none', border:'none', color:T.red, fontSize:13, cursor:'pointer', borderRadius:8 }}>
                      <Ic.Delete /> Delete post
                    </button>
                  )}
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>

        {/* Pravachan topic + vakta */}
        {!isPoll && !isThought && (
          <div style={{ padding:'0 14px 10px' }}>
            <p style={{ margin:0, fontSize:15, fontWeight:700, color:T.text, lineHeight:1.3 }}>{post.topic}</p>
            {post.vakta && (
              <span style={{ display:'inline-block', marginTop:4, fontSize:11, fontWeight:600, color:T.accent, background:T.accentBg, borderRadius:20, padding:'2px 10px', border:`1px solid rgba(194,97,10,0.25)` }}>{post.vakta}</span>
            )}
          </div>
        )}

        {/* Poll */}
        {isPoll && <PollCard post={post} currentUid={currentUid} onVote={onVote} />}

        {/* Thought — rendered as rich HTML, same card chrome as a normal post + media */}
        {isThought && (
          <div style={{ padding:'4px 14px 12px' }}>
            <div
              style={{ fontSize:16, color:T.text, lineHeight:1.65 }}
              dangerouslySetInnerHTML={{ __html: post.thoughtText || '' }}
            />
            {media.length > 0 && (
              <div onClick={handleDoubleTap}>
                <ThreadMediaGallery
                  media={media}
                  onOpenLightbox={(i) => setLightbox({ images: media.filter(m => m.type === 'image').map(m => m.url), startIdx: i })}
                />
              </div>
            )}
          </div>
        )}

        {/* Images — new gallery (pravachan / image posts) */}
        {images.length > 0 && (
          <div onClick={handleDoubleTap}>
            <PostImageGallery images={images} onOpenLightbox={(i) => setLightbox({ images, startIdx: i })} />
          </div>
        )}

        {/* Audio */}
        {audios.length > 0 && (
          <div style={{ padding:'8px 14px', display:'flex', flexDirection:'column', gap:8 }}>
            {audios.map((url, i) => <MiniAudioPlayer key={i} src={url} />)}
          </div>
        )}

        {/* PDF attachments */}
        {pdfs.length > 0 && (
          <div style={{ padding:'4px 14px 8px', display:'flex', flexDirection:'column', gap:6 }}>
            {pdfs.map((pdf, i) => <FeedPdfCard key={i} pdf={pdf} />)}
          </div>
        )}

        {/* Caption */}
        {post.caption && (
          <div style={{ padding:'4px 14px 8px' }}>
            <p style={{ margin:0, fontSize:14, color:T.text, lineHeight:1.55 }}>
              <span style={{ fontWeight:700, marginRight:6 }}>{post.displayName}</span>
              {post.caption}
            </p>
          </div>
        )}

        {/* Notes — render as formatted HTML (preserves bold/italic/color from the editor) */}
        {post.notes && (
          <div style={{ padding:'0 14px 8px' }}>
            <div
              className="feed-rich-notes"
              style={{
                fontSize:13, color:T.text, lineHeight:1.6,
                maxHeight: expanded || !isLong ? 'none' : 64,
                overflow:'hidden',
              }}
              dangerouslySetInnerHTML={{ __html: post.notes }}
            />
            {isLong && (
              <button onClick={(e) => { e.stopPropagation(); setExpanded(v => !v); }}
                style={{ background:'none', border:'none', color:T.accent, fontSize:12, fontWeight:700, cursor:'pointer', padding:'2px 0', marginTop:4, textDecoration:'underline', textUnderlineOffset:2 }}>
                {expanded ? 'Show less' : 'Read more'}
              </button>
            )}
          </div>
        )}

        {/* Action bar */}
        {!isPoll && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'6px 14px 10px', borderTop:`1px solid ${T.border}` }}>
            <div style={{ display:'flex', alignItems:'center', gap:18 }}>
              <motion.button whileTap={{ scale:1.3 }} onClick={() => currentUid && onLike(post.id)}
                style={{ background:'none', border:'none', cursor: currentUid ? 'pointer' : 'default', color: liked ? T.red : T.muted, display:'flex', alignItems:'center', gap:5 }}>
                <Ic.Heart fill={liked} />
                <span style={{ fontSize:13, fontWeight:600, color: liked ? T.red : T.muted }}>{post.likeCount||0}</span>
              </motion.button>
              <button onClick={() => { setShowComments(!showComments); setTimeout(() => inputRef.current?.focus(), 150); }}
                style={{ background:'none', border:'none', cursor:'pointer', color:T.muted, display:'flex', alignItems:'center', gap:5 }}>
                <Ic.Comment />
                <span style={{ fontSize:13, fontWeight:600, color:T.muted }}>{post.commentCount||0}</span>
              </button>
              <button onClick={() => onShare(post)} style={{ background:'none', border:'none', cursor:'pointer', color:T.muted }}>
                <Ic.Share />
              </button>
            </div>
            <button onClick={() => currentUid && onSave(post.id)}
              style={{ background:'none', border:'none', cursor: currentUid ? 'pointer' : 'default', color: saved ? T.accent : T.muted }}>
              <Ic.Bookmark fill={saved} />
            </button>
          </div>
        )}

        {isPoll && (
          <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', padding:'6px 14px 10px', borderTop:`1px solid ${T.border}` }}>
            <button onClick={() => currentUid && onSave(post.id)}
              style={{ background:'none', border:'none', cursor: currentUid ? 'pointer' : 'default', color: saved ? T.accent : T.muted }}>
              <Ic.Bookmark fill={saved} />
            </button>
          </div>
        )}

        {/* Comments */}
        <AnimatePresence>
          {showComments && (
            <motion.div initial={{ height:0, opacity:0 }} animate={{ height:'auto', opacity:1 }} exit={{ height:0, opacity:0 }}
              style={{ borderTop:`1px solid ${T.border}`, overflow:'hidden' }}>
              <div style={{ padding:'10px 14px', maxHeight:200, overflowY:'auto', display:'flex', flexDirection:'column', gap:8 }}>
                {comments.slice(-8).map((c) => {
                  const isMyComment = currentUid && currentUid === c.userId;
                  return (
                    <div key={c.id} style={{ display:'flex', alignItems:'flex-start', gap:8 }}>
                      <div style={{ width:28, height:28, borderRadius:'50%', flexShrink:0, background:'linear-gradient(135deg,#1D9E75,#0F6E56)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, color:'#fff' }}>{c.avatarInitial}</div>
                      <div style={{ background:T.surface2, borderRadius:12, padding:'7px 11px', flex:1 }}>
                        <span style={{ fontSize:11, fontWeight:700, color:T.text, marginRight:6 }}>{c.displayName}</span>
                        <span style={{ fontSize:12, color:T.muted }}>{c.text}</span>
                      </div>
                      {isMyComment && (
                        <button onClick={() => onDeleteComment(post.id, c.id)}
                          style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:'4px', borderRadius:6, flexShrink:0, marginTop:4 }}>
                          <Ic.Delete />
                        </button>
                      )}
                    </div>
                  );
                })}
                {comments.length === 0 && <p style={{ fontSize:12, color:T.muted, textAlign:'center', margin:0 }}>No comments yet</p>}
              </div>
              {currentUid ? (
                <div style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 14px 12px' }}>
                  <input ref={inputRef} value={commentText} onChange={e => setCommentText(e.target.value)}
                    onKeyDown={e => e.key==='Enter' && submit()}
                    placeholder="Add a comment…"
                    style={{ flex:1, background:T.surface2, border:`1px solid ${T.border}`, borderRadius:20, padding:'9px 14px', fontSize:13, color:T.text, outline:'none', fontFamily:'inherit' }} />
                  <button onClick={submit} disabled={!commentText.trim()} style={{ width:34, height:34, borderRadius:'50%', background: commentText.trim() ? T.accent : T.border, border:'none', color:'#fff', cursor: commentText.trim() ? 'pointer' : 'not-allowed', display:'flex', alignItems:'center', justifyContent:'center', transition:'background 0.15s' }}><Ic.Send /></button>
                </div>
              ) : (
                <p style={{ fontSize:12, textAlign:'center', color:T.muted, padding:'8px 14px 12px' }}>
                  <Link to="/login" style={{ color:T.accent, fontWeight:600 }}>Sign in</Link> to comment
                </p>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </article>
    </>
  );
}

// ─── Thought Composer — rich text (bold/italic/underline/color) + photo/video upload ──
function ThoughtComposer({ currentUser, userProfile, onPost, onClose }) {
  const editorRef = useRef(null);
  const fileRef = useRef(null);
  const [media, setMedia] = useState([]); // { url, type: 'image'|'video', name }
  const [uploading, setUploading] = useState(false);
  const [uploadCount, setUploadCount] = useState({ done: 0, total: 0 });
  const [submitting, setSubmitting] = useState(false);
  const [isEmpty, setIsEmpty] = useState(true);

  const checkEmpty = () => setIsEmpty(!editorRef.current || editorRef.current.innerText.trim().length === 0);

  const uploadOne = (file) => {
    const isVideo = file.type.startsWith('video/');
    const name = `thought_${Date.now()}_${Math.random().toString(36).slice(2,7)}_${file.name}`;
    return new Promise((resolve, reject) => {
      const sRef = storageRef(storage, `Thoughts/${name}`);
      const task = uploadBytesResumable(sRef, file);
      task.on('state_changed', () => {}, reject, async () => {
        try {
          const url = await getDownloadURL(task.snapshot.ref);
          resolve({ url, type: isVideo ? 'video' : 'image', name });
        } catch (err) { reject(err); }
      });
    });
  };

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setUploading(true);
    setUploadCount({ done: 0, total: files.length });
    for (const file of files) {
      try {
        const item = await uploadOne(file);
        setMedia(prev => [...prev, item]);
      } catch (err) {
        console.error('Thought media upload failed:', err);
      } finally {
        setUploadCount(prev => ({ ...prev, done: prev.done + 1 }));
      }
    }
    setUploading(false);
    e.target.value = '';
  };

  const removeMedia = (name) => setMedia(prev => prev.filter(m => m.name !== name));

  const submit = async () => {
    const html = editorRef.current?.innerHTML || '';
    if (isEmpty && media.length === 0) return;
    if (!currentUser || !userProfile) return;
    setSubmitting(true);
    await onPost(html, media);
    setSubmitting(false);
    onClose();
  };

  const canPost = (!isEmpty || media.length > 0) && !submitting && !uploading;

  return (
    <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, y:20 }}
      style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:16, padding:16, marginBottom:12, boxShadow:T.shadowMd }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
        <span style={{ fontSize:13, fontWeight:700, color:T.text }}>Share a thought</span>
        <button onClick={onClose} style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:4 }}><Ic.Close /></button>
      </div>

      {/* Formatting toolbar — same pattern as the Pravachan rich-text editor */}
      <div style={{ display:'flex', gap:4, padding:'2px 0 10px', alignItems:'center', flexWrap:'wrap' }}>
        {[
          { cmd:'bold', icon:<Ic.Bold /> },
          { cmd:'italic', icon:<Ic.Italic /> },
          { cmd:'underline', icon:<span style={{ fontSize:12, textDecoration:'underline', fontWeight:600 }}>U</span> },
        ].map(b => (
          <button key={b.cmd} type="button" onMouseDown={e => { e.preventDefault(); document.execCommand(b.cmd); editorRef.current?.focus(); }}
            style={{ width:28, height:28, border:`1px solid ${T.border}`, borderRadius:6, background:T.surface2, color:T.text, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>{b.icon}</button>
        ))}
        <div style={{ width:1, height:18, background:T.border, margin:'0 4px' }} />
        {[T.text, T.accent, '#1D9E75', T.red, '#2563EB'].map(c => (
          <button key={c} type="button" onMouseDown={e => { e.preventDefault(); document.execCommand('styleWithCSS', false, 'true'); document.execCommand('foreColor', false, c); editorRef.current?.focus(); }}
            style={{ width:18, height:18, borderRadius:'50%', background:c, border:`2px solid ${T.border}`, cursor:'pointer' }} />
        ))}
      </div>

      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        data-placeholder="What's on your mind?"
        onInput={checkEmpty}
        onPaste={e => { e.preventDefault(); document.execCommand('insertText', false, e.clipboardData.getData('text/plain')); }}
        style={{ minHeight:80, background:T.surface2, border:`1px solid ${T.border}`, borderRadius:12, padding:'12px 14px', fontSize:14, color:T.text, lineHeight:1.6, outline:'none' }}
      />

      {/* Media previews — horizontal scroll */}
      {media.length > 0 && (
        <div style={{ display:'flex', gap:8, marginTop:10, overflowX:'auto', paddingBottom:2 }}>
          {media.map(m => (
            <div key={m.name} style={{ position:'relative', width:80, height:80, borderRadius:10, overflow:'hidden', flexShrink:0, border:`1px solid ${T.border}`, background:'#111' }}>
              {m.type === 'video'
                ? <video src={m.url} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                : <img src={m.url} style={{ width:'100%', height:'100%', objectFit:'cover' }} />}
              <button onClick={() => removeMedia(m.name)}
                style={{ position:'absolute', top:3, right:3, background:'rgba(0,0,0,0.6)', border:'none', borderRadius:'50%', width:18, height:18, color:'#fff', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', padding:0 }}>
                <Ic.Close />
              </button>
              {m.type === 'video' && (
                <div style={{ position:'absolute', bottom:3, left:3, background:'rgba(0,0,0,0.6)', borderRadius:6, padding:'1px 5px', color:'#fff', fontSize:9, fontWeight:700 }}>VIDEO</div>
              )}
            </div>
          ))}
        </div>
      )}

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:12 }}>
        <button onClick={() => fileRef.current?.click()} disabled={uploading} type="button"
          style={{ display:'flex', alignItems:'center', gap:6, background:'none', border:`1px solid ${T.border}`, borderRadius:20, padding:'6px 12px', color: uploading ? T.muted : T.accent, fontSize:12, fontWeight:600, cursor: uploading ? 'not-allowed' : 'pointer' }}>
          <Ic.ImageIcon />
          {uploading ? `Uploading ${uploadCount.done}/${uploadCount.total}…` : 'Add photo/video'}
        </button>
        <input ref={fileRef} type="file" accept="image/*,video/*" multiple onChange={handleFiles} style={{ display:'none' }} />

        <button onClick={submit} disabled={!canPost}
          style={{ background: canPost ? T.accent : T.border, color: canPost ? '#fff' : T.muted, border:'none', borderRadius:20, padding:'8px 20px', fontSize:13, fontWeight:700, cursor: canPost ? 'pointer' : 'not-allowed', transition:'all 0.15s' }}>
          {submitting ? '…' : 'Post Thought'}
        </button>
      </div>
    </motion.div>
  );
}

// ─── Poll Composer ────────────────────────────────────────────
function PollComposer({ currentUser, userProfile, onPost, onClose }) {
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState(['', '']);
  const [isAnon, setIsAnon] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const addOption = () => { if (options.length < 5) setOptions([...options, '']); };
  const removeOption = (i) => { if (options.length > 2) setOptions(options.filter((_,idx) => idx !== i)); };
  const updateOption = (i, v) => setOptions(options.map((o,idx) => idx===i ? v : o));
  const canPost = question.trim() && options.filter(o => o.trim()).length >= 2;
  const submit = async () => {
    if (!canPost || !currentUser || !userProfile) return;
    setSubmitting(true);
    await onPost(question.trim(), options.filter(o => o.trim()), isAnon);
    setSubmitting(false);
    onClose();
  };
  return (
    <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, y:20 }}
      style={{ background:T.surface, border:`1px solid ${T.border}`, borderRadius:16, padding:16, marginBottom:12, boxShadow:T.shadowMd }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
        <span style={{ fontSize:13, fontWeight:700, color:T.text }}>Create a Poll</span>
        <button onClick={onClose} style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:4 }}><Ic.Close /></button>
      </div>
      <input value={question} onChange={e => setQuestion(e.target.value)} placeholder="Ask a question…"
        style={{ width:'100%', boxSizing:'border-box', background:T.surface2, border:`1px solid ${T.border}`, borderRadius:12, padding:'11px 14px', fontSize:14, color:T.text, fontFamily:'inherit', outline:'none', marginBottom:10 }} />
      <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:10 }}>
        {options.map((opt, i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', gap:8 }}>
            <input value={opt} onChange={e => updateOption(i, e.target.value)} placeholder={`Option ${i+1}`}
              style={{ flex:1, background:T.surface2, border:`1px solid ${T.border}`, borderRadius:10, padding:'9px 12px', fontSize:13, color:T.text, fontFamily:'inherit', outline:'none' }} />
            {options.length > 2 && <button onClick={() => removeOption(i)} style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:4 }}><Ic.Close /></button>}
          </div>
        ))}
        {options.length < 5 && <button onClick={addOption} style={{ background:'none', border:`1px dashed ${T.border}`, borderRadius:10, padding:'8px 12px', fontSize:13, color:T.muted, cursor:'pointer', fontFamily:'inherit' }}>+ Add option</button>}
      </div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <button onClick={() => setIsAnon(!isAnon)} style={{ display:'flex', alignItems:'center', gap:6, background: isAnon ? T.accentBg : 'none', border:`1px solid ${isAnon ? T.accent : T.border}`, borderRadius:20, padding:'6px 12px', fontSize:12, fontWeight:600, color: isAnon ? T.accent : T.muted, cursor:'pointer' }}>
          <Ic.Anon /> {isAnon ? 'Anonymous' : 'Show voters'}
        </button>
        <button onClick={submit} disabled={!canPost || submitting}
          style={{ background: canPost ? T.accent : T.border, color: canPost ? '#fff' : T.muted, border:'none', borderRadius:20, padding:'8px 20px', fontSize:13, fontWeight:700, cursor: canPost ? 'pointer' : 'not-allowed' }}>
          {submitting ? '…' : 'Post Poll'}
        </button>
      </div>
    </motion.div>
  );
}

// ─── Main Feed ────────────────────────────────────────────────
export default function PublicFeed() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [posts, setPosts]         = useState([]);
  const [loading, setLoading]     = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [tab, setTab]             = useState('posts');
  const [userProfile, setUserProfile] = useState(null);
  const [composer, setComposer]   = useState(null);

  useEffect(() => {
    if (!currentUser) return;
    get(ref(dbRealtime, `users/${currentUser.uid}/profile`)).then(snap => {
      if (snap.exists()) {
        const p = snap.val();
        const name = `${p.firstName||''} ${p.lastName||''}`.trim() || currentUser.email?.split('@')[0] || 'Devotee';
        setUserProfile({ displayName: name, avatarUrl: p.avatarUrl });
      } else {
        setUserProfile({ displayName: currentUser.email?.split('@')[0] || 'Devotee' });
      }
    }).catch(()=>{});
  }, [currentUser]);

  const fetchFeed = useCallback(async () => {
    setRefreshing(true);
    try {
      const snap = await get(ref(dbRealtime, 'publicFeed'));
      if (!snap.exists()) { setPosts([]); return; }
      const raw = snap.val();
      const arr = Object.entries(raw).map(([id, v]) => ({
        id, ...v,
        likeCount:    Object.keys(v.likes||{}).length,
        commentCount: Object.keys(v.comments||{}).length,
      }));
      setPosts(arr.sort((a,b) => b.createdAt - a.createdAt));
    } catch (e) { console.error(e); }
    finally { setLoading(false); setRefreshing(false); }
  }, []);

  useEffect(() => { fetchFeed(); }, [fetchFeed]);

  const visiblePosts = tab === 'saved'
    ? posts.filter(p => currentUser && !!(p.saves?.[currentUser.uid]))
    : posts;

  const handleLike = async (postId) => {
    if (!currentUser) return;
    const uid = currentUser.uid;
    const post = posts.find(p => p.id === postId);
    if (!post) return;
    const had = !!(post.likes?.[uid]);
    await update(ref(dbRealtime), { [`publicFeed/${postId}/likes/${uid}`]: had ? null : true });
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const nl = { ...p.likes }; if (had) delete nl[uid]; else nl[uid] = true;
      return { ...p, likes: nl, likeCount: Object.keys(nl).length };
    }));
  };

  const handleComment = async (postId, text) => {
    if (!currentUser || !userProfile) return;
    const id = `cmt_${Date.now()}`;
    const c = { id, userId: currentUser.uid, displayName: userProfile.displayName, avatarInitial: userProfile.displayName.charAt(0).toUpperCase(), text, createdAt: Date.now() };
    await update(ref(dbRealtime), { [`publicFeed/${postId}/comments/${id}`]: c });
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const nc = { ...p.comments, [id]: c };
      return { ...p, comments: nc, commentCount: Object.keys(nc).length };
    }));
  };

  const handleDeleteComment = async (postId, commentId) => {
    if (!currentUser) return;
    const post = posts.find(p => p.id === postId);
    if (!post) return;
    const comment = post.comments?.[commentId];
    if (!comment || comment.userId !== currentUser.uid) return;
    await update(ref(dbRealtime), { [`publicFeed/${postId}/comments/${commentId}`]: null });
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const nc = { ...p.comments }; delete nc[commentId];
      return { ...p, comments: nc, commentCount: Object.keys(nc).length };
    }));
  };

  const handleSave = async (postId) => {
    if (!currentUser) return;
    const uid = currentUser.uid;
    const post = posts.find(p => p.id === postId);
    if (!post) return;
    const had = !!(post.saves?.[uid]);
    await update(ref(dbRealtime), { [`publicFeed/${postId}/saves/${uid}`]: had ? null : true });
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const ns = { ...p.saves }; if (had) delete ns[uid]; else ns[uid] = true;
      return { ...p, saves: ns };
    }));
  };

  // FIXED: was building the share URL from `post.id` (e.g. "thought_uid_172..."),
  // which does NOT match the `/shared-pravachan/:userId/:timestamp` route and
  // always produced "Pravachan not found". The route needs the raw numeric
  // timestamp, which is `post.createdAt` (the same `ts` used to build both the
  // kathaAmrut key and the publicFeed key in Pravachan.tsx).
  const handleShare = async (post) => {
    const url = `${window.location.origin}/shared-pravachan/${post.userId}/${post.createdAt}`;
    try {
      if (navigator.share) await navigator.share({ title: post.topic || post.question || 'Satsang', url });
      else { await navigator.clipboard.writeText(url); alert('Link copied!'); }
    } catch {}
  };

  const handleDelete = async (postId) => {
    if (!currentUser || !window.confirm('Delete this post?')) return;
    const post = posts.find(p => p.id === postId);
    if (!post || post.userId !== currentUser.uid) return;
    await update(ref(dbRealtime), { [`publicFeed/${postId}`]: null });
    setPosts(prev => prev.filter(p => p.id !== postId));
  };

  const handleVote = async (postId, optionIndex) => {
    if (!currentUser) return;
    const uid = currentUser.uid;
    await update(ref(dbRealtime), { [`publicFeed/${postId}/pollVotes/${uid}`]: optionIndex });
    setPosts(prev => prev.map(p => {
      if (p.id !== postId) return p;
      const nv = { ...p.pollVotes, [uid]: optionIndex };
      return { ...p, pollVotes: nv };
    }));
  };

  // UPDATED: now stores rich HTML (from the contentEditable thought composer)
  // and an optional array of uploaded photo/video media.
  const handlePostThought = async (html, media) => {
    if (!currentUser || !userProfile) return;
    const ts = Date.now();
    const feedId = `thought_${currentUser.uid}_${ts}`;
    const data = {
      type:'thought',
      userId:currentUser.uid,
      displayName:userProfile.displayName,
      avatarInitial:userProfile.displayName.charAt(0).toUpperCase(),
      avatarUrl:userProfile.avatarUrl||null,
      thoughtText:html,
      media: media || [],
      topic:'', vakta:'', dateTime:new Date(ts).toISOString(), createdAt:ts,
      likes:{}, comments:{}, saves:{},
    };
    await update(ref(dbRealtime), { [`publicFeed/${feedId}`]: data });
    setPosts(prev => [{ id: feedId, ...data, likeCount:0, commentCount:0 }, ...prev]);
  };

  const handlePostPoll = async (question, options, isAnon) => {
    if (!currentUser || !userProfile) return;
    const ts = Date.now();
    const feedId = `poll_${currentUser.uid}_${ts}`;
    const data = { type:'poll', userId:currentUser.uid, displayName:isAnon?'Anonymous':userProfile.displayName, avatarInitial:isAnon?'A':userProfile.displayName.charAt(0).toUpperCase(), avatarUrl:isAnon?null:(userProfile.avatarUrl||null), question, pollOptions:options, pollAnonymous:isAnon, pollVotes:{}, topic:question, vakta:'', dateTime:new Date(ts).toISOString(), createdAt:ts, likes:{}, comments:{}, saves:{} };
    await update(ref(dbRealtime), { [`publicFeed/${feedId}`]: data });
    setPosts(prev => [{ id: feedId, ...data, likeCount:0, commentCount:0 }, ...prev]);
  };

  return (
    <div style={{ minHeight:'100vh', background:T.bg, fontFamily:"-apple-system,'Helvetica Neue',sans-serif", color:T.text }}>
      <header style={{ position:'sticky', top:0, zIndex:50, background:'rgba(247,245,240,0.95)', backdropFilter:'blur(12px)', borderBottom:`1px solid ${T.border}` }}>
        <div style={{ maxWidth:480, margin:'0 auto', padding:'12px 16px', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <div>
            <h1 style={{ fontFamily:'Georgia,serif', fontSize:22, fontWeight:700, margin:0, letterSpacing:'-0.02em', color:T.text }}>Satsang</h1>
            <p style={{ margin:0, fontSize:11, color:T.muted }}>Community feed</p>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <button onClick={fetchFeed} disabled={refreshing}
              style={{ background:'none', border:'none', color:T.muted, cursor:'pointer', padding:8, borderRadius:'50%', animation: refreshing ? 'spin 1s linear infinite' : 'none' }}>
              <Ic.Refresh />
            </button>
            {currentUser && (
              <button onClick={() => navigate('/pravachan')} style={{ display:'flex', alignItems:'center', gap:6, background:T.accent, color:'#fff', border:'none', borderRadius:20, padding:'8px 16px', fontSize:13, fontWeight:700, cursor:'pointer', boxShadow:'0 2px 8px rgba(194,97,10,0.3)' }}>
                <Ic.Plus /> Post
              </button>
            )}
          </div>
        </div>
        <div style={{ maxWidth:480, margin:'0 auto', display:'flex', padding:'0 16px 10px', gap:8, alignItems:'center' }}>
          {[{ key:'posts', label:'Posts' }, { key:'saved', label:'Saved' }].map(t => (
            <button key={t.key} onClick={() => setTab(t.key)} style={{ padding:'6px 18px', borderRadius:20, border:`1px solid ${tab===t.key ? T.text : T.border}`, cursor:'pointer', fontSize:13, fontWeight:700, background: tab===t.key ? T.text : T.surface, color: tab===t.key ? T.bg : T.muted, transition:'all 0.15s' }}>{t.label}</button>
          ))}
          {currentUser && tab === 'posts' && (
            <div style={{ marginLeft:'auto', display:'flex', gap:6 }}>
              <button onClick={() => setComposer(composer==='thought' ? null : 'thought')}
                style={{ display:'flex', alignItems:'center', gap:5, padding:'5px 12px', borderRadius:20, border:`1px solid ${composer==='thought' ? '#1D9E75' : T.border}`, background: composer==='thought' ? 'rgba(29,158,117,0.08)' : T.surface, color: composer==='thought' ? '#1D9E75' : T.muted, fontSize:12, fontWeight:600, cursor:'pointer' }}>
                💬 Thought
              </button>
              <button onClick={() => setComposer(composer==='poll' ? null : 'poll')}
                style={{ display:'flex', alignItems:'center', gap:5, padding:'5px 12px', borderRadius:20, border:`1px solid ${composer==='poll' ? '#7C3AED' : T.border}`, background: composer==='poll' ? 'rgba(124,58,237,0.08)' : T.surface, color: composer==='poll' ? '#7C3AED' : T.muted, fontSize:12, fontWeight:600, cursor:'pointer' }}>
                📊 Poll
              </button>
            </div>
          )}
        </div>
      </header>

      <main style={{ maxWidth:480, margin:'0 auto', padding:'12px 12px 80px' }}>
        <AnimatePresence>
          {composer === 'thought' && currentUser && (
            <ThoughtComposer key="thought" currentUser={currentUser} userProfile={userProfile} onPost={handlePostThought} onClose={() => setComposer(null)} />
          )}
          {composer === 'poll' && currentUser && (
            <PollComposer key="poll" currentUser={currentUser} userProfile={userProfile} onPost={handlePostPoll} onClose={() => setComposer(null)} />
          )}
        </AnimatePresence>

        {loading ? (
          [1,2,3].map(i => <Skeleton key={i} />)
        ) : visiblePosts.length === 0 ? (
          <div style={{ textAlign:'center', padding:'80px 24px' }}>
            <div style={{ fontSize:48, marginBottom:16 }}>{tab==='saved' ? '🔖' : '🙏'}</div>
            <h3 style={{ fontSize:18, fontWeight:700, margin:'0 0 8px', color:T.text }}>{tab==='saved' ? 'Nothing saved yet' : 'No posts yet'}</h3>
            <p style={{ color:T.muted, fontSize:14, margin:'0 0 24px' }}>{tab==='saved' ? 'Save posts to find them here.' : 'Be the first to share a pravachan.'}</p>
            {tab==='posts' && (currentUser
              ? <button onClick={() => navigate('/pravachan')} style={{ background:T.accent, color:'#fff', border:'none', borderRadius:24, padding:'12px 28px', fontSize:14, fontWeight:700, cursor:'pointer' }}>Create post</button>
              : <Link to="/login" style={{ display:'inline-block', background:T.accent, color:'#fff', textDecoration:'none', borderRadius:24, padding:'12px 28px', fontSize:14, fontWeight:700 }}>Sign in to post</Link>
            )}
          </div>
        ) : (
          <AnimatePresence>
            {visiblePosts.map(post => (
              <motion.div key={post.id} initial={{ opacity:0, y:12 }} animate={{ opacity:1, y:0 }} exit={{ opacity:0, scale:0.97 }}>
                <PostCard post={post} currentUid={currentUser?.uid || null}
                  onLike={handleLike} onComment={handleComment} onDeleteComment={handleDeleteComment}
                  onSave={handleSave} onShare={handleShare} onDelete={handleDelete} onVote={handleVote} />
              </motion.div>
            ))}
          </AnimatePresence>
        )}
      </main>

      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        ::-webkit-scrollbar { display: none; }
        * { box-sizing: border-box; }
        [contenteditable]:empty:before { content: attr(data-placeholder); color: ${T.muted}; pointer-events: none; }
        .feed-rich-notes p { margin: 0 0 6px; }
        .feed-rich-notes:last-child p:last-child { margin-bottom: 0; }
        @media (max-width: 480px) {
          header > div { padding-left: 12px !important; padding-right: 12px !important; }
        }
      `}</style>
    </div>
  );
}